module.exports = __webpack_public_path__ + "assets/img/question-bj.44fdafc1.png";